import { use } from 'react';

import { Grid } from '@mui/material';

import { generalInformation } from '~constants';
import { UserRoleEnum } from '~enums';
import useAuthorize from '~hooks/useAuthorize';

import Dimens from '../../../themes/dimens';
import AssignmentCard from '../components/cards/assignmentCard';
import KeyInformationCard from '../components/cards/keyInformationCard';
import KeyActionBar from '../components/keyActionBar';
import KeyContext from '../providers/keyContext';

/**
 * Todo: This whole component needs loading and error states
 */
const KeyDetailsContainer = () => {
	const auth = useAuthorize();
	const keyContext = use(KeyContext);
	const keyId = keyContext.key?.id ?? '0';
	const organisationId = keyContext.overwrittenClientId;
	const isSuperAdmin = auth.authorize([UserRoleEnum.SuperAdmin]);
	const canManageKeyDetailsActions = auth.authorize([
		UserRoleEnum.SuperAdmin,
		UserRoleEnum.Manufacturing,
		UserRoleEnum.Support,
	]);

	return (
		<>
			<KeyActionBar
				keyId={keyId}
				organisationId={organisationId}
				showUnassignButton={
					isSuperAdmin &&
					organisationId != undefined &&
					organisationId != generalInformation.manufacturingOrganisationId
				}
				showEditButton={canManageKeyDetailsActions}
				showDeleteButton={canManageKeyDetailsActions}
				showAssignButton={
					canManageKeyDetailsActions &&
					organisationId == generalInformation.manufacturingOrganisationId
				}
				showChangeResourceGroupButton={
					canManageKeyDetailsActions &&
					organisationId != generalInformation.manufacturingOrganisationId
				}
			/>
			<Grid
				container
				spacing={Dimens.spacingXl}
				direction={'row'}
				sx={{
					alignItems: 'stretch',
				}}
			>
				<Grid size={{ xs: 12, md: 6 }}>
					<KeyInformationCard keyId={keyId} organisationId={organisationId} />
				</Grid>
				<Grid size={{ xs: 12, md: 6 }}>
					<AssignmentCard keyId={keyId} organisationId={organisationId} />
				</Grid>
			</Grid>
		</>
	);
};

export default KeyDetailsContainer;
